<template>
  <div class="insurance-list-items">
    <img class="logo" :src="icon" />
    <div class="meta">
      <router-link class="name" :to="route">{{ title }}</router-link>
      <p class="desc">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "subtitle", "icon", "route"]
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 50px;

.insurance-list-items {
  display: flex;
  border-bottom: $border;

  > .logo {
    height: $logoSize;
    widows: $logoSize;
    margin: 10px;
  }
  > .meta {
    margin: 10px;
  }

  > .meta > .name {
    line-height: 1.6;
    display: inline-block;

    &:hover {
      color: black;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/features/insurance/components/InsuranceListItem.vue